import { SxProps, Theme } from '@mui/material';

type Styles = {
  assetManagerContainer: SxProps<Theme>;
  assetManager: SxProps<Theme>;
  headerText: SxProps<Theme>;
  formContainer: SxProps<Theme>;
  container: SxProps<Theme>;
  containerText: SxProps<Theme>;
  buttonBlock: SxProps<Theme>;
};

export const styles: Styles = {
  assetManagerContainer: {
    position: 'relative',
    minHeight: '100vh',
    display: 'flex',
    background: 'white',
    letterSpacing: '-1px',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100vh',
  },

  assetManager: (theme: Theme) => ({
    width: '50%',
    height: 'auto',
    padding: '30px 45px 30px',
    boxSizing: 'border-box',
    borderRadius: '18px',
    boxShadow: '7px 7px 40px 0 rgba(217, 217, 217, 0.8)',
    background: 'white',
    [theme.breakpoints.down('md')]: {
      width: '70%',
      padding: '35px 50px',
    },
    [theme.breakpoints.down('sm')]: {
      width: '80%',
      padding: '25px',
    },
  }),

  headerText: (theme: Theme) => ({
    textAlign: 'center',
    color: theme.palette.primary.main,
    fontSize: '26px',
    [theme.breakpoints.down('sm')]: {
      fontSize: '22px',
    },
  }),

  formContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: 1.5,
  },

  container: (theme: Theme) => ({
    display: 'flex',
    gap: 1.5,
    alignItems: 'flex-start',
    p: 1,
    [theme.breakpoints.down('sm')]: {
      gap: 1,
      p: 0.5,
    },
  }),

  containerText: (theme: Theme) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: 16,
    [theme.breakpoints.down('sm')]: {
      fontSize: 14,
    },
  }),

  buttonBlock: () => ({
    display: 'flex',
    justifyContent: 'center',
    marginTop: '15px',
  }),
};
